module.exports = __webpack_public_path__ + "images/circle-spinner-458a4f0798e205554b9c0b5571db4b47.gif";